import styled from "styled-components";
import { Dialog } from "@material-ui/core";
// CONSTANTS
import { responsive } from "Styles/Constants";
import { IMAGES } from "Helpers";

export const GamePageWrapper = styled.div`
	background-image: linear-gradient(0deg, transparent 1%, rgba(255, 255, 255, 0) 100%), url(${IMAGES.ENGLISH.CROSSWORD.HOME_BACKGROUND});
	background-repeat: no-repeat;
	/* background-size: cover; */
	min-height: 100vh;
	background-size: 100% 100%;
	background-position: center;
	/* background-repeat: no-repeat; */
	${responsive.DESKTOP`
    min-width:98vw;
    `}
	${responsive.LAPTOP`
    width:125vw;
    `}

    .sub-container {
		display: flex;
		flex-direction: column;
		padding-top: 8%;

		.heading-container {
			display: flex;
			justify-content: center;
			margin-top: -35px;
			.heading {
				font-family: Rubik;
				font-size: 44px;
				@media only screen and (min-width: 720px) and (max-width: 960px) {
					font-size: 36px;
				}
				font-weight: bold;
				font-stretch: normal;
				font-style: normal;
				line-height: normal;
				letter-spacing: 2.4px;
				text-align: center;
				color: #fff;
				text-shadow: rgb(1, 32, 47) 10px 0px 0px, rgb(1, 32, 47) 9.95004px 0.998334px 0px, rgb(1, 32, 47) 9.80067px 1.98669px 0px, rgb(1, 32, 47) 9.55336px 2.9552px 0px,
					rgb(1, 32, 47) 9.21061px 3.89418px 0px, rgb(1, 32, 47) 8.77583px 4.79426px 0px, rgb(1, 32, 47) 8.25336px 5.64642px 0px, rgb(1, 32, 47) 7.64842px 6.44218px 0px,
					rgb(1, 32, 47) 6.96707px 7.17356px 0px, rgb(1, 32, 47) 6.2161px 7.83327px 0px, rgb(1, 32, 47) 5.40302px 8.41471px 0px, rgb(1, 32, 47) 4.53596px 8.91207px 0px,
					rgb(1, 32, 47) 3.62358px 9.32039px 0px, rgb(1, 32, 47) 2.67499px 9.63558px 0px, rgb(1, 32, 47) 1.69967px 9.8545px 0px, rgb(1, 32, 47) 0.707372px 9.97495px 0px,
					rgb(1, 32, 47) -0.291995px 9.99574px 0px, rgb(1, 32, 47) -1.28844px 9.91665px 0px, rgb(1, 32, 47) -2.27202px 9.73848px 0px, rgb(1, 32, 47) -3.2329px 9.463px 0px,
					rgb(1, 32, 47) -4.16147px 9.09297px 0px, rgb(1, 32, 47) -5.04846px 8.63209px 0px, rgb(1, 32, 47) -5.88501px 8.08496px 0px, rgb(1, 32, 47) -6.66276px 7.45705px 0px,
					rgb(1, 32, 47) -7.37394px 6.75463px 0px, rgb(1, 32, 47) -8.01144px 5.98472px 0px, rgb(1, 32, 47) -8.56889px 5.15501px 0px, rgb(1, 32, 47) -9.04072px 4.2738px 0px,
					rgb(1, 32, 47) -9.42222px 3.34988px 0px, rgb(1, 32, 47) -9.70958px 2.39249px 0px, rgb(1, 32, 47) -9.89993px 1.4112px 0px, rgb(1, 32, 47) -9.99135px 0.415807px 0px,
					rgb(1, 32, 47) -9.98295px -0.583741px 0px, rgb(1, 32, 47) -9.8748px -1.57746px 0px, rgb(1, 32, 47) -9.66798px -2.55541px 0px, rgb(1, 32, 47) -9.36457px -3.50783px 0px,
					rgb(1, 32, 47) -8.96758px -4.4252px 0px, rgb(1, 32, 47) -8.481px -5.29836px 0px, rgb(1, 32, 47) -7.90968px -6.11858px 0px, rgb(1, 32, 47) -7.25932px -6.87766px 0px,
					rgb(1, 32, 47) -6.53644px -7.56803px 0px, rgb(1, 32, 47) -5.74824px -8.18277px 0px, rgb(1, 32, 47) -4.90261px -8.71576px 0px, rgb(1, 32, 47) -4.00799px -9.16166px 0px,
					rgb(1, 32, 47) -3.07333px -9.51602px 0px, rgb(1, 32, 47) -2.10796px -9.7753px 0px, rgb(1, 32, 47) -1.12153px -9.93691px 0px, rgb(1, 32, 47) -0.123887px -9.99923px 0px,
					rgb(1, 32, 47) 0.87499px -9.96165px 0px, rgb(1, 32, 47) 1.86512px -9.82453px 0px, rgb(1, 32, 47) 2.83662px -9.58924px 0px, rgb(1, 32, 47) 3.77978px -9.25815px 0px,
					rgb(1, 32, 47) 4.68517px -8.83455px 0px, rgb(1, 32, 47) 5.54374px -8.32267px 0px, rgb(1, 32, 47) 6.34693px -7.72764px 0px, rgb(1, 32, 47) 7.0867px -7.0554px 0px,
					rgb(1, 32, 47) 7.75566px -6.31267px 0px, rgb(1, 32, 47) 8.34713px -5.50686px 0px, rgb(1, 32, 47) 8.8552px -4.64602px 0px, rgb(1, 32, 47) 9.27478px -3.73877px 0px,
					rgb(1, 32, 47) 9.6017px -2.79415px 0px, rgb(1, 32, 47) 9.83268px -1.82162px 0px, rgb(1, 32, 47) 9.96542px -0.830894px 0px;
			}
		}
		.progress {
			margin-top: 5%;
			display: flex;
			justify-content: center;
			align-items: center;
			height: 200px;
		}

		.game-container {
			display: flex;
			padding: 1rem 0rem;
			justify-content: space-around;

			.overlay-table {
				position: relative;
				width: 100%;
				margin: 0px auto;
				opacity: 0.7;
				font-weight: bolder;
				display: flex;

				.display-circular-progress {
					position: absolute;
					top: 30%;
					left: 50%;
					margin: 0;
					.progress {
						width: 50px;
						height: 50px;
					}
				}
			}

			.crossword {
				/* width: 70%; */
				margin: 0px auto;
				font-weight: bolder;
				margin-left: 1em;
				/* @media only screen and (min-width: 720px) and (max-width: 960px) {
					width: 85%;
				}
				@media only screen and (min-width: 960px) and (max-width: 1100px) {
					width: 85%;
				}
				@media only screen and (min-width: 1100px) and (max-width: 1200px) {
					width: 80%;
				}
				@media only screen and (min-width: 2000px) {
					width: 65%;
				} */
				svg {
					.clue-cell rect {
						stroke: #5a3600;
						stroke-width: 0.6px;
						stroke-linejoin: round;
						/* rx: 2px; */
					}
				}
			}

			.guess-text-incorrect {
				fill: red !important;
				animation: fadeIn 5s;
				/* text-shadow: 1px 2px 4px #000; */
			}

			.guess-text-correct {
				fill: rgb(34, 139, 34) !important;

				animation: fadeIn 5s;
				user-select: none;
				/* text-shadow: 1px 2px 4px #000; */
			}

			@keyframes fadeIn {
				0% {
					opacity: 0;
				}
				100% {
					opacity: 1;
				}
			}

			/* .clues {
		display: none;
	} */
		}
	}
`;

export const DialogWrapper = styled(Dialog)`
	.background-root {
		background-color: rgba(0, 0, 0, 0.8);
	}
	.paper {
		background: transparent;
		color: black;
		overflow: visible;
	}

	.paper-width {
		max-width: 900px;
	}
	.box-modal {
		/* height: 650px;
		width: 850px; */
		/* background-repeat: no-repeat;
		background-size: 100% 100%; */
		background-image: url(${IMAGES.ENGLISH.CROSSWORD.RULES_BACKGROUND});
		/* background-position: center;
		position: relative; */

		width: 860px;
		height: 670px;
		position: relative;
		background-size: contain;
		background-repeat: no-repeat;

		${responsive.DISPLAY`
			width: 740px;
			height: 570px;
		`}

		${responsive.DESKTOP`
			width: 660px;
    		height: 510px;
		`}

		.title-container {
			.sub-title {
				font-size: 27px;
				margin-top: 25px;
				margin-left: 20px;
				color: #fff;

				${responsive.DESKTOP`
					font-size: 22px;
					margin-left: 0px;
					margin-top: 20px;
				`}
			}

			.icon-container {
				cursor: pointer;
				position: absolute;
				right: 89px;
				top: 116px;
				z-index: 3;

				${responsive.LAPTOP`
					top: 100px;
				`}
				.icon {
					color: #ffea7d;
					font-size: 35px;
				}
			}
		}
		.content-wrapper {
			height: 500px;
			position: relative;
			padding: 15px;

			${responsive.DISPLAY`
				height: 393px;
				font-size: 14px;
			`}

			${responsive.DESKTOP`
				height: 350px;
				font-size: 12px;
			`}


			.scroll-bar {
				.thumb-vertical {
					background-color: #ffea7d;
					margin-left: -63px;
					margin-top: 40px;
				}
			}
			.content {
				width: 80%;
				margin: 2% auto 0px;
				color: #fff;
			}

			.attach-file {
				display: flex;
				justify-content: center;

				.icon {
					color: #fff;
				}

				.file {
					margin: 0px 10px;
					font-size: 18px;
					cursor: pointer;
					text-decoration: underline;
					color: #fff;
				}

				.pdf-loader {
					width: 20px !important;
					height: 20px !important;
					color: #fff;
					margin-top: 1px;
				}
			}

			.progress {
				position: absolute;
				top: 36%;
				left: 0;
				right: 0;
				color: #000;
			}

			.type-switcher {
				.divider {
					background-color: #fff;
					height: 2px;
					width: 50%;
					margin: 5px auto;
					opacity: 0.5;
				}

				.text {
					cursor: pointer;
					transition: 0.3s;
					margin: 0px 0px 22px 20px;
					color: #fff;
				}
			}
		}
		.play-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			position: absolute;
			bottom: 0;
			.play {
				font-size: 26px;
				cursor: pointer;
				color: #fff;
				border: 3px solid #ffea7d;
				width: fit-content;
				border-radius: 20px;
				padding: 10px 20px;
				background-color: #771c1c;
				text-align: center;

				${responsive.DISPLAY`
					font-size: 20px;
				`}

				${responsive.DESKTOP`
					font-size: 18px;
				`}
			}
		}
	}
`;
